export function formatNumber(num) {
    if (!num) return num;
    return num
        .toString()
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

export function formatYear(num) {
    let array = num.split('/');
    if (array.length === 2) return array[1];
    else return num;
}

export function formatDate(date, fullDate = true) {
    if (date) {
        let newDate = new Date(date);
        if (fullDate === true) {
            let day = ('0' + newDate.getDate()).toString().substr(-2);
            let month = ('0' + (newDate.getMonth() + 1)).slice(-2);
            let year = newDate.getFullYear().toString().substr(-2);
            return (newDate = day + '/' + month + '/' + year);
        } else {
            let month = newDate.getMonth() + 1;
            month = month < 10 ? `0${month}` : month;
            return (newDate = `${month}/${newDate.getFullYear()}`);
        }
    } else return null;
}

export function formatPrice(num, round) {
    if (isNaN(num)) {
        return num;
    }
    const formatter = new Intl.NumberFormat('ca', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
    });

    let roundedNumber = Math.round(num);
    if (round) num = roundedNumber < num ? roundedNumber + 1 : roundedNumber;

    return formatter.format(num);
}

export function getLocationWithoutCampa(location) {
    let locationAux = location;
    if (location.indexOf('Campa: ') <= 0) {
        locationAux = location.replace('Campa: ', '');
        if (locationAux) locationAux.trim();
    }

    return locationAux;
}

export function getLiteralVehicleDescription(selectedVehicle) {
    let modelDescriptionModified = '';
    if (selectedVehicle?.ModelLong && selectedVehicle?.Brand) {
        const capitalizedBrand =
            selectedVehicle.Brand.charAt(0).toUpperCase() +
            selectedVehicle.Brand.toLowerCase().slice(1);
        if (selectedVehicle.ModelLong.indexOf(capitalizedBrand) <= 0) {
            modelDescriptionModified = selectedVehicle.ModelLong.replace(
                `${capitalizedBrand} ${
                    selectedVehicle?.Model ? selectedVehicle?.Model.trim() : ''
                }`,
                ''
            );

            if (modelDescriptionModified)
                modelDescriptionModified = modelDescriptionModified.trim();
        }
    }
    return modelDescriptionModified;
}

export function checkValidBidFormat(value) {
    if (value % 100 === 0) return true;
    else return false;
}

export function checkAuctionIsActive(
    startDate,
    endDate,
    currentDate,
    upcoming
) {
    if (startDate && endDate && currentDate) {
        const dateStart = new Date(startDate).getTime();
        const dateEnd = new Date(endDate).getTime();
        if (upcoming) return currentDate > dateStart;
        return currentDate > dateStart && dateEnd > currentDate;
    }
    return false;
}

export function checkCountDownStatus(startDate, endDate, currentDate) {
    let status = 0; //por empezar
    let dateStart = new Date(startDate).getTime();
    let dateEnd = new Date(endDate).getTime();
    if (currentDate >= dateStart) status = 1; //activa
    if (currentDate >= dateEnd) status = 2; //finalizada
    return status;
}

export function getReceptorVehicleLocation(vehicle) {
    let location = '';
    if (vehicle) {
        if (vehicle.Type) location += vehicle.Type + ' ';
        if (vehicle.Address) location += vehicle.Address + ' ';
        if (vehicle.AddressNumber) location += vehicle.AddressNumber;
        if (vehicle.Floor) location += ' ' + vehicle.Floor;
        if (vehicle.PostalCode) location += ', ' + vehicle.PostalCode;
        if (vehicle.Province) location += ' ' + vehicle.Province.Description;
    }

    return location;
}

export const getCountDownStyles = (status, vehicle, translations) => {
    let label = '';
    let classes;

    if (
        vehicle?.Status === 2 &&
        (vehicle?.PublicationDate || vehicle?.PublicationEndDate)
    ) {
        classes = ['c-vehicle-card__tag-counter'];

        if (status === 0) {
            label = translations.getTraduction('EmpiezaEn') + ' ';
            classes.push('light-blue');
        }

        const extensionNumber = vehicle.PublicationCurrentExtension;
        const extensionNumberMax = vehicle.PublicationMaxExtension;

        if (status === 1 && !extensionNumber) {
            label = translations.getTraduction('FinalizaEn') + ' ';
            classes.push('light-blue');
        }

        if (extensionNumber > 0 && extensionNumberMax > 0) {
            classes.push('warning');
            if (extensionNumber < extensionNumberMax) {
                label =
                    extensionNumber +
                    translations.getTraduction('ExtensionNumber') +
                    ' ';
            } else {
                label = translations.getTraduction('LastExtension') + ' ';
            }
        }
    }
    return { label, classes };
};

export const parseDecimal = value => {
    const parsedValue = value.replace(/[^\d,]/g, '');
    let decimals = '';
    const comma = parsedValue.indexOf(',');
    if (comma !== -1) {
        decimals = parsedValue.slice(comma, comma + 3).replace(/[^\d]/g, '');
    }

    return `${parsedValue.slice(
        0,
        comma !== -1 ? comma + 1 : parsedValue.length
    )}${decimals}`;
};
